/**
 * Devices shared-reorder session writers (#999 Story 3.9 / #1401).
 * Collapses the ×6 step switch in RequestDetail.handleDevicesReorder.
 */

import {
  applyVisibleUnitsReorder,
  type OrderableUnit,
} from './applyVisibleUnitsReorder';

import type { DeviceStepId } from './deviceRowMapper';

export type DevicesReorderSessionWriter<T extends OrderableUnit> = {
  getSessionUnits: () => readonly T[] | undefined;
  setSessionUnits: (units: T[]) => void;
};

export type DevicesReorderSessionMap = Partial<{
  [K in DeviceStepId]: DevicesReorderSessionWriter<OrderableUnit>;
}>;

/**
 * Apply a visible-subset reorder to the edit-session list for `stepId`.
 * @returns false when the session writer is missing (not ready).
 */
export function applyDevicesStepReorder(
  sessions: DevicesReorderSessionMap,
  stepId: DeviceStepId,
  visibleUnits: readonly OrderableUnit[],
  fromIndex: number,
  toIndex: number,
): boolean {
  const writer = sessions[stepId];
  if (!writer) {
    return false;
  }
  const session = writer.getSessionUnits();
  if (!session) {
    return false;
  }
  writer.setSessionUnits(
    applyVisibleUnitsReorder(session, visibleUnits, fromIndex, toIndex),
  );
  return true;
}
